import type { FactoryWithDependencies } from '@wix/thunderbolt-ioc'
import { withDependencies } from '@wix/thunderbolt-ioc'
import { HeadContentSymbol, HeadContentType as ThunderboltHeadContentType } from '@wix/thunderbolt-symbols'
import type { IHeadContent, ServiceProvider } from '@wix/thunderbolt-symbols'
import { HeadAppenderDefinition as definition } from '@wix/viewer-service-head-appender/definition'
import { HeadAppenderService as impl } from '@wix/viewer-service-head-appender/implementations'
import { HeadContentType as ViewerServiceHeadContentType } from '@wix/viewer-service-head-appender/types'

type IHeadAppenderDefinition = typeof definition

const toThunderboltHeadContentType = (type?: ViewerServiceHeadContentType): ThunderboltHeadContentType | undefined => {
	switch (type) {
		case ViewerServiceHeadContentType.SEO:
			return ThunderboltHeadContentType.SEO
		case ViewerServiceHeadContentType.SEO_DEBUG:
			return ThunderboltHeadContentType.SEO_DEBUG
		case ViewerServiceHeadContentType.AFTER_SECURITY:
			return ThunderboltHeadContentType.AFTER_SECURITY
		default:
			return undefined
	}
}

export const HeadAppenderService: FactoryWithDependencies<ServiceProvider<IHeadAppenderDefinition, typeof impl>> =
	withDependencies(
		[HeadContentSymbol],
		(headContent: IHeadContent): ServiceProvider<IHeadAppenderDefinition, typeof impl> => {
			return {
				definition,
				impl,
				config: {
					setHead: (content, type) => headContent.setHead(content, toThunderboltHeadContentType(type)),
				},
			}
		}
	)
